module.exports = __webpack_public_path__ + "static/media/006-sketch.41ab04aa.svg";